<template>
  <v-dialog v-model="dialog" persistent max-width="100%">
    <v-card>
      <v-form @submit.prevent="validar">
        <v-card-title class="pt-2 pb-0">CAMBIAR CUENTAS ORIGEN O DESTINO</v-card-title>

        <v-divider class="my-2"></v-divider>

        <v-card-text>
          <v-row>
            <v-col cols="12" md="6" lg="3">
              <v-select
                :items="sedes"
                item-text="nombre"
                item-value="id"
                outlined
                dense
                label="Sede origen"
                disabled
                hide-details
                :value="sedeOrigenSeleccionada"></v-select>
            </v-col>

            <v-col cols="12" md="6" lg="2">
              <vue-select
                v-model="datos_cuenta_origen"
                class="style-chooser"
                placeholder="Seleccione Cuenta Origen"
                label="nro"
                :options="cuentasOrigen">
                <div slot="no-options">Lo sentimos, no hay opciones de coincidencia.</div>

                <template #option="{ cuenta, nro }">
                  {{ nro }}
                  <br />
                  {{ cuenta }}
                </template>
              </vue-select>

              <small style="font-size: 12px">
                {{ `Originalmente: ${form?.detalle_solicitud[0]?.cuenta_origen}` }}
              </small>
            </v-col>

            <v-col cols="12" md="12" lg="2">
              <v-checkbox
                v-model="habilitadasOtrasSedesDestinos"
                label="Habilitar otras sedes destino"
                hide-details></v-checkbox>
            </v-col>

            <v-col cols="12" md="6" lg="3">
              <v-select
                :items="sedes"
                item-text="nombre"
                item-value="id"
                return-object
                outlined
                dense
                label="Sede destino"
                v-model="sedeDestinoSeleccionada"
                :disabled="!habilitadasOtrasSedesDestinos"
                :hint="`Originalmente: ${form?.detalle_solicitud[0]?.sede_destino}`"
                persistent-hint
                @change="obtenerNuevasCuentasDestino"></v-select>
            </v-col>

            <v-col cols="12" md="6" lg="2">
              <vue-select
                v-model="datos_cuenta_destino"
                class="style-chooser"
                placeholder="Seleccione Cuenta Destino"
                label="nro"
                :options="cuentasDestino">
                <div slot="no-options">Lo sentimos, no hay opciones de coincidencia.</div>

                <template #option="{ cuenta, nro, tipo }">
                  <span style="display: block; font-size: 1rem">
                    {{ nro }} <small style="font-size: 0.725rem">({{ tipo.toUpperCase() }})</small>
                  </span>
                  {{ cuenta }}
                </template>
              </vue-select>

              <small style="font-size: 12px">
                {{ `Originalmente: ${form?.detalle_solicitud[0]?.cuenta_destino}` }}
              </small>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                :value="form?.detalle_solicitud[0]?.clasificador"
                outlined
                dense
                label="Cuenta"
                hide-details
                disabled></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                :value="form?.detalle_solicitud[0]?.cuenta_contable"
                outlined
                dense
                label="Contable"
                hide-details
                disabled></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-textarea
                :value="form?.detalle_solicitud[0]?.detalle"
                outlined
                dense
                label="Detalle"
                hide-details
                disabled></v-textarea>
            </v-col>

            <v-col cols="12" md="6">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    :value="form?.detalle_solicitud[0]?.importe"
                    outlined
                    dense
                    label="Importe"
                    hide-details
                    disabled></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    :value="form?.detalle_solicitud[0]?.saldo"
                    outlined
                    dense
                    label="Saldo"
                    hide-details
                    disabled></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    :value="form?.detalle_solicitud[0]?.estado"
                    outlined
                    dense
                    label="Estado"
                    hide-details
                    disabled></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider class="my-2"></v-divider>

        <v-card-actions>
          <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>
          <v-btn color="blue darken-1" type="submit" text> Guardar </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>

    <ConfirmacionAccion
      ref="confirmacionAccion"
      :titulo="accion.titulo"
      :mensaje="accion.mensaje"
      :realizandoAccion="accion.realizandoAccion"
      maxWidth="1200"
      @aceptar="aceptarAccion">
      <v-form>
        <v-row>
          <v-col cols="12" style="padding-bottom: 0px !important">
            <v-textarea
              ref="observacionRef"
              outlined
              name="observaciones"
              label="Observaciones Anulación por Cambio de Cuentas Origen o Destino*"
              hide-details
              v-model="observaciones"></v-textarea>

            <span style="color: red">* Verifique la observacion por defecto</span>
          </v-col>
        </v-row>
      </v-form>
    </ConfirmacionAccion>
  </v-dialog>
</template>

<script>
import gql from 'graphql-tag';
import 'vue-select/dist/vue-select.css';
import ConfirmacionAccion from '@/components/ConfirmacionAccion';
import {
  obtenerTodasLasSedes,
  formatearCuentasBancarias,
  TIPOS_CUENTAS_BANCARIAS,
  TIPOS_SOLICITUD,
  ESTADOS_DETALLE_SOLICITUD,
  peticionCuentas1,
  peticionCuentas2,
} from '../utils';
import SolicitudServices from '../services/solicitud';

export default {
  name: 'ModalCambioCuentas',
  components: {
    ConfirmacionAccion,
  },
  computed: {
    totalImporteActual() {
      return this.form?.detalle_solicitud.reduce((a, b) => a + parseFloat(b.importe), 0);
    },
    sedeOrigenSeleccionada() {
      return this.sedes.find((sede) => sede.id === this.form?.detalle_solicitud[0]?.sede_origen_id);
    },
    esCambioCuentaOrigen() {
      return this.form?.detalle_solicitud[0]?.cuenta_origen_id != this.datos_cuenta_origen?.id;
    },
    esCambioCuentaDestino() {
      return this.form?.detalle_solicitud[0]?.cuenta_destino_id != this.datos_cuenta_destino?.id;
    },
    esCambioSedeDestino() {
      return this.form?.detalle_solicitud[0]?.sede_destino_id != this.sedeDestinoSeleccionada?.id;
    },
  },
  watch: {
    sedeOrigenSeleccionada(value) {
      if (value) {
        this.datos_cuenta_origen = {
          nombre: this.form?.detalle_solicitud[0]?.banco_origen,
          id: this.form?.detalle_solicitud[0]?.cuenta_origen_id,
          nro: this.form?.detalle_solicitud[0]?.cuenta_origen,
        };
      }
    },
    sedes(value) {
      if (value.length > 0) {
        this.sedeDestinoSeleccionada = this.sedes.find(
          (sede) => sede.id === this.form?.detalle_solicitud[0]?.sede_destino_id,
        );
      }
    },
    habilitadasOtrasSedesDestinos(value) {
      if (!value) {
        this.sedeDestinoSeleccionada = this.sedes.find(
          (sede) => sede.id === this.form?.detalle_solicitud[0]?.sede_destino_id,
        );

        this.datos_cuenta_destino = {
          nombre: this.form?.detalle_solicitud[0]?.banco_destino,
          id: this.form?.detalle_solicitud[0]?.cuenta_destino_id,
          nro: this.form?.detalle_solicitud[0]?.cuenta_destino,
        };
      }
    },
  },
  data() {
    return {
      dialog: false,
      form: {
        id: null,
        numero: null,
        created_at: null,
        estado: null,
        sede_origen: null,
        sede_origen_id: null,
        tipo: null,
        user: null,
        user_id: null,
        detalle_solicitud: [],
      },
      formularioEnviado: false,
      accion: {
        titulo: '',
        mensaje: '',
        realizandoAccion: false,
      },
      sedes: [],
      cuentasOrigen: [],
      cuentasDestino: [],
      observaciones: null,
      observacionesNuevoDetalleSolicitud: null,
      datos_cuenta_origen: null,
      datos_cuenta_destino: null,
      sedeDestinoSeleccionada: null,
      habilitadasOtrasSedesDestinos: false,
    };
  },
  methods: {
    async abrir(data, indice) {
      this.dialog = true;
      this.form.id = data.id;
      this.form.numero = data.numero;
      this.form.created_at = data.created_at;
      this.form.estado = data.estado;
      this.form.sede_origen = data.sede_origen;
      this.form.sede_origen_id = data.sede_origen_id;
      this.form.tipo = data.tipo;
      this.form.user = data.user;
      this.form.user_id = data.user_id;
      const { id, ...detalle } = data.detalle_solicitud[indice];
      this.form.detalle_solicitud = [
        {
          ...detalle,
          detalle_solicitud_rechazado_id: id,
        },
      ];

      const sedeOrigenId = detalle.sede_origen_id;
      const sedeDestinoId = detalle.sede_destino_id;

      this.datos_cuenta_destino = {
        nombre: this.form?.detalle_solicitud[0]?.banco_destino,
        id: this.form?.detalle_solicitud[0]?.cuenta_destino_id,
        nro: this.form?.detalle_solicitud[0]?.cuenta_destino,
      };

      this.habilitadasOtrasSedesDestinos = false;

      this.obtenerSedes();
      this.obtenerCuentasOrigen(sedeOrigenId);
      this.obtenerCuentasDestino(sedeDestinoId);
    },
    cerrar() {
      this.sedes = [];
      this.dialog = false;
    },
    validar() {
      if (this.form?.detalle_solicitud?.length <= 0) {
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'Debe agregar al menos un detalle de solicitud',
          type: 'error',
        });

        return;
      }

      if (!this.datos_cuenta_origen) {
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'Debe seleccionar una cuenta origen',
          type: 'error',
        });

        return;
      }

      if (!this.datos_cuenta_destino) {
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'Debe seleccionar una cuenta destino',
          type: 'error',
        });

        return;
      }

      if (
        this.form?.detalle_solicitud[0]?.cuenta_origen_id === this.datos_cuenta_origen?.id &&
        this.form?.detalle_solicitud[0]?.cuenta_destino_id === this.datos_cuenta_destino?.id
      ) {
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'Debe cambiar al menos una cuenta',
          type: 'error',
        });

        return;
      }

      const cuentaContable = this.form?.detalle_solicitud[0]?.cuenta_contable;
      const usuario =
        `${this.$store.state.DATA_USER.nombres} ${this.$store.state.DATA_USER.pri_apellido} ${this.$store.state.DATA_USER.seg_apellido}`
          .trim()
          .toUpperCase();

      const obs1 = this.esCambioCuentaOrigen
        ? ` - Cambio de cuenta origen (original): ${this.form.detalle_solicitud[0].banco_origen} - ${this.form.detalle_solicitud[0].cuenta_origen} a cuenta origen (actual): ${this.datos_cuenta_origen.nombre} - ${this.datos_cuenta_origen.nro}`
        : '';

      const obs2 = this.esCambioCuentaDestino
        ? ` - Cambio de cuenta destino (original): ${this.form.detalle_solicitud[0].banco_destino} - ${this.form.detalle_solicitud[0].cuenta_destino} a cuenta destino (actual): ${this.datos_cuenta_destino.nombre} - ${this.datos_cuenta_destino.nro}`
        : '';

      this.observacionesNuevoDetalleSolicitud = `Por cambio de cuentas bancarias solicitado por ${usuario} de la solicitud N° ${this.form.numero} con el detalle de solicitud con ${obs1}${obs2}`;
      this.accion.titulo = '¿SEGURO QUE DESEA CAMBIAR LAS CUENTAS ORIGEN O DESTINO?';
      this.accion.mensaje = /*html*/ `Se creará una nueva solicitud con la siguiente información
        <hr>
        <h5>SOLICITUD</h5>
        <strong>SOLICITANTE</strong>: ${this.form.user}
        <br><strong>ESTADO</strong>: ${this.form.estado}
        <br><strong>TIPO SOLICITUD</strong>: ${this.form.tipo == TIPOS_SOLICITUD.RECURSOS ? 'Sedes' : 'Nacional'}
        <h5>DETALLE DE SOLICITUD</h5>
        <strong>SEDE ORIGEN</strong>: ${this.form.detalle_solicitud[0].sede_origen}
        <br><strong>BANCO ORIGEN</strong>: ${this.datos_cuenta_origen.nombre}
        <br><strong>CUENTA ORIGEN${this.esCambioCuentaOrigen ? ' (CAMBIADA)' : ''}</strong>: ${
        this.datos_cuenta_origen.nro
      }
        <br><strong>SEDE DESTINO${this.esCambioSedeDestino ? ' (CAMBIADA)' : ''}</strong>: ${
        this.datos_cuenta_destino.sede
      }
        <br><strong>BANCO DESTINO</strong>: ${this.datos_cuenta_destino.nombre}
        <br><strong>CUENTA DESTINO${this.esCambioCuentaDestino ? ' (CAMBIADA)' : ''}</strong>: ${
        this.datos_cuenta_destino.nro
      }
        <br><strong>CUENTA</strong>: ${this.form.detalle_solicitud[0].clasificador}
        <br><strong>CONTABLE</strong>: ${cuentaContable ? cuentaContable : '-'}
        <br><strong>DETALLE</strong>: ${this.form.detalle_solicitud[0].detalle}
        <br><strong>ESTADO</strong>: ${this.form.detalle_solicitud[0].estado}
        <br><strong>IMPORTE</strong>: ${this.form.detalle_solicitud[0].importe}
        <br><strong>OBSERVACIÓN</strong>: ${this.observacionesNuevoDetalleSolicitud}
        <hr>
        Se anulará el detalle de solicitud con la siguiente observación:
        <hr>`;

      let observaciones = `Anulado por ${usuario}${obs1}${obs2}`;

      this.observaciones = observaciones;

      this.$refs.confirmacionAccion.abrir();
    },
    async aceptarAccion() {
      if (this.formularioEnviado) {
        return;
      }

      if (!this.esCambioCuentaOrigen && !this.esCambioCuentaDestino) {
        return;
      }

      this.accion.realizandoAccion = true;
      this.formularioEnviado = true;

      const datosDetalleSolicitud = {
        banco_origen: this.datos_cuenta_origen.nombre,
        cuenta_origen_id: this.datos_cuenta_origen.id,
        cuenta_origen: this.datos_cuenta_origen.nro,
        sede_destino: this.sedeDestinoSeleccionada.nombre,
        sede_destino_id: this.sedeDestinoSeleccionada.id,
        banco_destino: this.datos_cuenta_destino.nombre,
        cuenta_destino_id: this.datos_cuenta_destino.id,
        cuenta_destino: this.datos_cuenta_destino.nro,
        observaciones: this.observacionesNuevoDetalleSolicitud,
      };

      const { detalle_solicitud, ...resto } = this.form;

      resto.detalle_solicitud = [
        {
          ...detalle_solicitud[0],
          ...datosDetalleSolicitud,
        },
      ];

      const datos = {
        observaciones: this.observaciones,
        total: this.totalImporteActual,
        ...resto,
      };

      try {
        await SolicitudServices.storeCambiarCuentasDetalleSolicitud(datos);

        this.$emit('actualizarEstdoDetalleSolicitud', {
          id: this.form.detalle_solicitud[0].detalle_solicitud_rechazado_id,
          estado: ESTADOS_DETALLE_SOLICITUD.ANULADO,
        });

        this.$notify({
          group: 'notifications',
          title: 'EXITO',
          text: 'DETALLE DE SOLICITUD ANULADA Y SE CAMBIÓ LAS CUENTAS ORIGEN O DESTINO CORRECTAMENTE',
          type: 'success',
        });

        this.observaciones = null;
        this.$refs.confirmacionAccion.cerrar();
        this.dialog = false;
      } catch (error) {
        window.console.log(error);

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'Ocurrió un error al cambiar las cuentas origen o destino',
          type: 'error',
        });
      } finally {
        this.accion.realizandoAccion = false;
        this.formularioEnviado = false;
      }
    },
    async obtenerSedes() {
      this.sedes = await obtenerTodasLasSedes(this.$apollo);
    },
    async obtenerCuentasOrigen(sedeOrigenId) {
      const sql = gql`query{getSede(id: ${sedeOrigenId}) { id nombre cuentasBancarias {id nombre nro descripcion estado idsede}}}`;

      try {
        const respuesta = await this.$apollo.query({
          query: sql,
        });

        this.cuentasOrigen = respuesta?.data?.getSede?.cuentasBancarias.map((cuenta) => {
          return {
            ...cuenta,
            cuenta: `${cuenta.descripcion} - ${cuenta.nombre}`,
          };
        });
      } catch (error) {
        window.console.log(error);

        this.cuentasOrigen = [];
      }
    },
    async obtenerCuentasDestino(sedeDestinoId) {
      try {
        const [cuentasDestino1, cuentasDestino2] = await Promise.all([
          peticionCuentas1(sedeDestinoId),
          peticionCuentas2(sedeDestinoId, this.$apollo),
        ]);
        const cuentasDestino1Formateado = cuentasDestino1?.data?.datos?.map(
          formatearCuentasBancarias(TIPOS_CUENTAS_BANCARIAS.PAGADORA),
        );
        const cuentasDestino2Formateado = cuentasDestino2?.data?.getSede?.cuentasBancarias
          ? cuentasDestino2?.data?.getSede?.cuentasBancarias?.map(
              formatearCuentasBancarias(TIPOS_CUENTAS_BANCARIAS.RECAUDADORA),
            )
          : [];

        this.cuentasDestino = [...cuentasDestino1Formateado, ...cuentasDestino2Formateado];
      } catch (error) {
        window.console.log(error);
      }
    },
    obtenerNuevasCuentasDestino() {
      this.datos_cuenta_destino = null;
      const sedeDestinoId = this.sedeDestinoSeleccionada.id;

      this.obtenerCuentasDestino(sedeDestinoId);
    },
  },
};
</script>

<style scoped>
::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}
::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}
::v-deep .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer {
  margin-top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}

::v-deep .v-input--selection-controls {
  margin-top: 0px;
}
</style>